import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Inner } from 'components/Page';
import config from './config';

/*
 ** @description Prepare data for api
 ** @param props Object user, availability_cycle, start_datetime, end_datetime
 ** @return data object
 */
const handlePrepareData = ({
  user, availability_cycle, start_datetime, end_datetime
}) => ({
  user,
  availability_cycle_id: availability_cycle.key,
  start_datetime,
  end_datetime
});

const UserCycle = ({ canAdmin, objectId, permissions }) => (
  <Inner
    defaultSize="206px"
    canAdmin={canAdmin && permissions.CanAdminAvailabilities()
      .hasPermissions()}
    reducer={{
      item: REDUCER_KEY.userAvailabilityCycle,
      list: REDUCER_KEY.userAvailabilityCycles
    }}
    config={{
      ...config,
      list: {
        ...config.list,
        filters: {
          user: [objectId]
        }
      },
      detail: {
        ...config.detail,
        parent: {
          user: objectId
        }
      }
    }}
    scroll={{
      x: 800,
      y: '100%'
    }}
    onPrepareData={handlePrepareData}
    messaging={{
      delete: {
        disabled: () => 'Item Disabled.',
        failure: error => `Delete Failed. ${error}`,
        success: () => 'Delete Successful.'
      },
      save: {
        failure: () => 'Saving failed',
        success: () => 'Saving was successful'
      }
    }}
  />
);

UserCycle.propTypes = {
  canAdmin: PropTypes.bool,
  objectId: PropTypes.number,
  permissions: PropTypes.object.isRequired
};

UserCycle.defaultProps = {
  canAdmin: true,
  objectId: null
};

export default UserCycle;
